
import { UserData } from "../../../../../domain/entities/entities";
import { onBeforeMount, ref } from "vue";
import {
  disableBodyOverflow,
  isGTopTemplate,
} from "../../mixins";
import ModernInput from "./modernInput.vue";

export default {
  name: "IdentityForm",
  components: { ModernInput },
  setup() {
    const userData = ref(new UserData());
    onBeforeMount(() => disableBodyOverflow());

    const setDescriptionModal = (): string => {
      if (isGTopTemplate()) {
        return "Por favor, insira seus dados abaixo para validarmos sua identidade.";
      } else {
        return "Escolha um das opções abaixo para que possamos validar sua identidade.";
      }
    };
    return {
      userData,
      setDescriptionModal,
      isGTopTemplate
    };
  }
};
